import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabase';
import { saveUser } from '../auth';

export default function Inscription() {
  const navigate = useNavigate();
  const [prenom, setPrenom] = useState('');
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [erreur, setErreur] = useState('');
  const [step, setStep] = useState(1);
  const [nbInvites, setNbInvites] = useState(0);
  const [prenomSave, setPrenomSave] = useState('');
  const [userId, setUserId] = useState(null);

  const sinscrire = async () => {
    if (!prenom.trim()) { setErreur('Entre ton prénom'); return; }
    if (!email.trim() || !email.includes('@')) { setErreur('Email invalide'); return; }
    setLoading(true);
    setErreur('');

    try {
      const emailLower = email.toLowerCase().trim();

      // Vérifier si déjà inscrit
      const { data: existing } = await supabase
        .from('users')
        .select('*')
        .eq('email', emailLower)
        .maybeSingle();

      if (existing) {
        saveUser(existing);
        const redirect = localStorage.getItem('wooki_redirect_after_inscription');
        if (redirect) { localStorage.removeItem('wooki_redirect_after_inscription'); navigate(redirect); }
        else navigate('/feed');
        return;
      }

      // Créer nouveau compte
      const newId = crypto.randomUUID();

      // Vérifier parrain
      const urlParams = new URLSearchParams(window.location.search);
      const parrainPrenom = urlParams.get('parrain');
      let parrainId = null;
      if (parrainPrenom) {
        const { data: parrainData } = await supabase
          .from('users')
          .select('id')
          .eq('prenom', parrainPrenom)
          .maybeSingle();
        if (parrainData) parrainId = parrainData.id;
      }

      const { data: newUser, error: insertError } = await supabase
        .from('users')
        .insert({
          id: newId,
          prenom: prenom.trim(),
          email: emailLower,
          parrain_id: parrainId,
          nb_filleuls: 0,
          super_famille: false,
        })
        .select()
        .single();

      if (insertError) {
        console.log('Erreur insert:', insertError);
        setErreur('Erreur inscription. Réessaie.');
        setLoading(false);
        return;
      }

      saveUser(newUser);
      setUserId(newId);
      setPrenomSave(prenom.trim());
      setStep(2);

    } catch (e) {
      console.log('Erreur:', e);
      setErreur('Erreur réseau. Réessaie.');
    }
    setLoading(false);
  };

  const handlePartage = async (methode) => {
    const lien = `https://wooki.app/inscription?parrain=${encodeURIComponent(prenomSave)}`;
    const texte = `Salut ! Je viens de rejoindre Wooki 🌿\n\nDes familles de mon quartier organisent des sorties ensemble !\n\nRejoins-nous ! 👉 ${lien}`;
    if (methode === 'whatsapp') window.open(`https://wa.me/?text=${encodeURIComponent(texte)}`, '_blank');
    else if (methode === 'sms') window.open(`sms:?body=${encodeURIComponent(texte)}`, '_blank');
    else { await navigator.clipboard.writeText(lien); alert('Lien copié !'); }
    const newNb = nbInvites + 1;
    setNbInvites(newNb);
    if (newNb >= 3 && userId) {
      await supabase.from('users').update({ super_famille: true }).eq('id', userId);
    }
  };

  const terminer = () => {
    const redirect = localStorage.getItem('wooki_redirect_after_inscription');
    if (redirect) { localStorage.removeItem('wooki_redirect_after_inscription'); navigate(redirect); }
    else navigate('/feed');
  };

  // ÉTAPE 2 — PARRAINAGE
  if (step === 2) return (
    <div style={{ minHeight: '100vh', background: '#FAFAF7', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '24px' }}>
      <style>{`@keyframes pop{0%{transform:scale(0);opacity:0}70%{transform:scale(1.2)}100%{transform:scale(1);opacity:1}}`}</style>
      <div style={{ width: '100%', maxWidth: 380 }}>
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <div style={{ fontSize: '3.5rem', marginBottom: 12, animation: 'pop 0.5s ease both' }}>🌿</div>
          <div style={{ fontFamily: 'Fredoka One, cursive', fontSize: '1.6rem', color: '#1C2B1E', marginBottom: 8 }}>
            Bienvenue {prenomSave} !
          </div>
          <div style={{ fontSize: '0.88rem', color: '#4A6355', lineHeight: 1.7 }}>
            Invite <strong>3 familles</strong> et deviens une <strong style={{ color: '#FFB300' }}>Super Famille Wooki</strong> 🏆
          </div>
        </div>

        <div style={{ background: 'linear-gradient(135deg, #1C2B1E, #2D7A52)', borderRadius: 24, padding: '20px', marginBottom: 20, textAlign: 'center' }}>
          <div style={{ fontSize: '2.5rem', marginBottom: 8 }}>🏆</div>
          <div style={{ fontFamily: 'Fredoka One, cursive', fontSize: '1rem', color: 'white', marginBottom: 4 }}>Badge Super Famille</div>
          <div style={{ fontSize: '0.78rem', color: 'rgba(255,255,255,0.7)', marginBottom: 14 }}>Invite 3 familles pour débloquer</div>
          <div style={{ display: 'flex', gap: 8, justifyContent: 'center' }}>
            {[0, 1, 2].map(i => (
              <div key={i} style={{ width: 44, height: 44, borderRadius: '50%', background: i < nbInvites ? '#3D9A6A' : 'rgba(255,255,255,0.15)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.2rem', border: i < nbInvites ? '2px solid #52C289' : '2px solid rgba(255,255,255,0.2)' }}>
                {i < nbInvites ? '✓' : '👨‍👩‍👧'}
              </div>
            ))}
          </div>
          <div style={{ fontSize: '0.72rem', color: 'rgba(255,255,255,0.6)', marginTop: 8 }}>{nbInvites}/3 familles invitées</div>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginBottom: 16 }}>
          <button onClick={() => handlePartage('whatsapp')} style={{ width: '100%', padding: '16px', background: '#25D366', color: 'white', border: 'none', borderRadius: 100, fontFamily: 'Nunito, sans-serif', fontWeight: 800, fontSize: '0.95rem', cursor: 'pointer' }}>
            💬 Inviter sur WhatsApp
          </button>
          <button onClick={() => handlePartage('sms')} style={{ width: '100%', padding: '16px', background: '#3D9A6A', color: 'white', border: 'none', borderRadius: 100, fontFamily: 'Nunito, sans-serif', fontWeight: 800, fontSize: '0.95rem', cursor: 'pointer' }}>
            📱 Inviter par SMS
          </button>
          <button onClick={() => handlePartage('copier')} style={{ width: '100%', padding: '16px', background: '#EDF7F1', color: '#3D9A6A', border: '2px solid #C5DFC9', borderRadius: 100, fontFamily: 'Nunito, sans-serif', fontWeight: 800, fontSize: '0.95rem', cursor: 'pointer' }}>
            🔗 Copier le lien
          </button>
        </div>

        <button onClick={terminer} style={{ width: '100%', padding: '16px', background: '#EDF7F1', color: '#3D9A6A', border: '2px solid #C5DFC9', borderRadius: 100, fontFamily: 'Nunito, sans-serif', fontWeight: 800, fontSize: '0.95rem', cursor: 'pointer' }}>
          🌿 Voir les activités !
        </button>
      </div>
    </div>
  );

  // ÉTAPE 1 — FORMULAIRE
  return (
    <div style={{ minHeight: '100vh', background: '#FAFAF7', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '24px' }}>
      <div style={{ width: '100%', maxWidth: 380 }}>
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <div onClick={() => navigate('/feed')} style={{ fontFamily: 'Fredoka One, cursive', fontSize: '2rem', marginBottom: 12, cursor: 'pointer' }}>
            <span style={{ color: '#3D9A6A' }}>Woo</span><span style={{ color: '#FF7043' }}>ki</span>
          </div>
          <div style={{ fontFamily: 'Fredoka One, cursive', fontSize: '1.3rem', color: '#1C2B1E', marginBottom: 6 }}>Rejoins Wooki 🌿</div>
          <div style={{ fontSize: '0.85rem', color: '#8A9E8D', lineHeight: 1.6 }}>Sorties en famille — Gratuit et sécurisé</div>
        </div>

        <div style={{ background: 'white', borderRadius: 28, padding: '28px 24px', boxShadow: '0 8px 32px rgba(28,43,30,0.08)' }}>
          <div style={{ marginBottom: 16 }}>
            <label style={{ fontSize: '0.78rem', fontWeight: 800, color: '#4A6355', textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 8, display: 'block' }}>Ton prénom</label>
            <input
              value={prenom}
              onChange={e => setPrenom(e.target.value)}
              placeholder="Ex: Sophie"
              style={{ width: '100%', padding: '14px 16px', border: '2px solid #E8EFE9', borderRadius: 16, fontFamily: 'Nunito, sans-serif', fontSize: '1rem', outline: 'none', background: '#FAFAF7', boxSizing: 'border-box' }}
            />
          </div>
          <div style={{ marginBottom: 8 }}>
            <label style={{ fontSize: '0.78rem', fontWeight: 800, color: '#4A6355', textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 8, display: 'block' }}>Ton email</label>
            <input
              value={email}
              onChange={e => setEmail(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && sinscrire()}
              placeholder="exemple@gmail.com"
              type="email"
              style={{ width: '100%', padding: '14px 16px', border: '2px solid #E8EFE9', borderRadius: 16, fontFamily: 'Nunito, sans-serif', fontSize: '1rem', outline: 'none', background: '#FAFAF7', boxSizing: 'border-box' }}
            />
          </div>
          <div style={{ fontSize: '0.72rem', color: '#8A9E8D', marginBottom: 20, paddingLeft: 4 }}>
            🔒 Uniquement pour te reconnecter. Jamais de spam.
          </div>
          {erreur && (
            <div style={{ background: '#FFF3EE', color: '#FF7043', padding: '10px 14px', borderRadius: 12, fontSize: '0.82rem', marginBottom: 14, textAlign: 'center' }}>
              {erreur}
            </div>
          )}
          <button onClick={sinscrire} disabled={loading} style={{ width: '100%', padding: '17px', background: loading ? '#E8EFE9' : '#3D9A6A', color: loading ? '#8A9E8D' : 'white', border: 'none', borderRadius: 100, fontFamily: 'Nunito, sans-serif', fontWeight: 900, fontSize: '1rem', cursor: loading ? 'not-allowed' : 'pointer', boxShadow: loading ? 'none' : '0 6px 20px rgba(61,154,106,0.35)' }}>
            {loading ? '⏳ Inscription...' : '🌿 Rejoindre Wooki !'}
          </button>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, margin: '16px 0' }}>
            <div style={{ flex: 1, height: 1, background: '#E8EFE9' }} />
            <div style={{ fontSize: '0.75rem', color: '#8A9E8D' }}>déjà inscrit ?</div>
            <div style={{ flex: 1, height: 1, background: '#E8EFE9' }} />
          </div>
          <button onClick={() => navigate('/connexion')} style={{ width: '100%', padding: '14px', background: 'transparent', color: '#3D9A6A', border: '2px solid #C5DFC9', borderRadius: 100, fontFamily: 'Nunito, sans-serif', fontWeight: 700, fontSize: '0.88rem', cursor: 'pointer' }}>
            Me connecter →
          </button>
        </div>

        <div style={{ display: 'flex', gap: 16, justifyContent: 'center', marginTop: 20 }}>
          {['🆓 Gratuit', '🔒 Sécurisé', '👨‍👩‍👧 Entre familles'].map((b, i) => (
            <div key={i} style={{ fontSize: '0.72rem', color: '#8A9E8D', fontWeight: 700 }}>{b}</div>
          ))}
        </div>
      </div>
    </div>
  );
}